import React, { Fragment, Component } from 'react';

export default class Header extends Component {
    render() {
        return (
            <Fragment>
                <div style={{height: "10%"} }>
                    <img className="mainHeader" src={require('../images/masthead_new.png')} /> 
                    <br/>
                </div>
            </Fragment>)
    }
}